import { Controller } from '@hotwired/stimulus';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class extends Controller {
    // Define the target for the image element
    static targets = ['image'];

    connect() {
        // Set the initial scale of the image
        gsap.set(this.imageTarget, {
            opacity: 0,
            y: -50 // Optional: slight move up for a more dynamic "reveal"
        });

        // Create the GSAP animation that links to the scroll position
        gsap.to(this.imageTarget, {
            opacity: 1,
            y: 0, // Optional: move to original position
            ease: 'power1.out',
            scrollTrigger: {
                trigger: this.element, // The parent div for each item is the trigger
                start: 'top bottom+=150', // Start when the top of the item is 50px from the bottom of the viewport
                toggleActions: 'play none none none', // Play the animation once when entering, then do nothing
            },
        });
    }
}
